import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_GET_APARTMENTS_LIST,
} from 'api/actionTypes';

export default async function getApartmentsListAction({ state, apiClient }) {
  const apartmentsList = state.get(['apartmentLocator', 'apartmentsList']);
  if (apartmentsList) {
    return apartmentsList;
  }
  return apiClient.postWithState({
    action: SR_API_ACTION_GET_APARTMENTS_LIST,
    state: state,
    onSuccess(apartmentsList) {
      typeCheck('apartmentsList::Array', apartmentsList);
      state.set(['apartmentLocator', 'apartmentsList'], apartmentsList);
      return apartmentsList;
    },
  });
}
